module.exports = __webpack_public_path__ + "assets/Social-spotify.cb6b504f.svg";